import { featureEnabled, isCustomerAdmin, userFeatureEnabled } from "./helpers";

export interface KnowledgebaseNgMayInterface {
  (session: SessionInterface, path: "knowledgebase_ng"): boolean;
  (session: SessionInterface, path: "knowledgebase_ng", action: "new" | "igor_sync"): boolean;
  (
    session: SessionInterface,
    path: "knowledgebase_ng",
    action: "show" | "edit" | "delete" | "histories",
    article: KnowledgebaseNgArticlePermissionResource,
  ): boolean;

  (session: SessionInterface, path: "knowledgebase_ng/categories"): boolean;
  (session: SessionInterface, path: "knowledgebase_ng/categories", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "knowledgebase_ng/categories",
    action: "show" | "edit" | "delete",
    article: KnowledgebaseNgCategory,
  ): boolean;

  (session: SessionInterface, path: "knowledgebase_ng/reviews"): boolean;

  (
    session: SessionInterface,
    path: "knowledgebase_ng/reviews",
    action: "create",
    article: KnowledgebaseNgArticlePermissionResource,
  ): boolean;

  (
    session: SessionInterface,
    path: "knowledgebase_ng/reviews",
    action: "review",
    review: [KnowledgebaseNgArticlePermissionResource, KnowledgebaseNgReview],
  ): boolean;
}

const KnowledgebaseNgArticlePermissions: PermissionType<KnowledgebaseNgArticlePermissionResource> = {
  knowledgebase_ng: {
    index: ({ currentUser, currentProject }) => featureEnabled(currentUser, currentProject, "knowledgebase"),
    edit: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write"),
    delete: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write"),
    new: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write"),
    igor_sync: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write") &&
      featureEnabled(currentUser, currentProject, "knowledgebase-igor-sync"),
  },
};

const ReviewPermissions: PermissionType<any> = {
  "knowledgebase_ng/reviews": {
    index: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write"),

    create: ({ currentUser, currentCustomer, currentProject }, article: KnowledgebaseNgArticlePermissionResource) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write") &&
      ["DRAFT", "NEEDS_REVIEW", "EXPIRED"].includes(article.status) &&
      (currentUser.id === article.ownerId || isCustomerAdmin(currentUser, currentCustomer)),

    review: ({ currentUser, currentProject }, [article, review]) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write") &&
      article.ownerId !== currentUser.id &&
      ["DRAFT", "NEEDS_REVIEW", "EXPIRED"].includes(article.status) &&
      review.result === "REQUESTED",
  },
};

const KnowledgebaseNgCategoryPermissions: PermissionType<KnowledgebaseNgCategory> = {
  "knowledgebase_ng/categories": {
    index: ({ currentUser, currentProject }) => featureEnabled(currentUser, currentProject, "knowledgebase"),
    edit: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write"),
    delete: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write"),
    new: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "knowledgebase") &&
      userFeatureEnabled(currentUser, "knowledgebase_write"),
  },
};

const KnowledgebaseNgPermissions = {
  ...KnowledgebaseNgArticlePermissions,
  ...ReviewPermissions,
  ...KnowledgebaseNgCategoryPermissions,
};

export default KnowledgebaseNgPermissions;
